export default __webpack_public_path__ + "static/media/Hundred.5112447e.jpeg";